import timezoneMapping from "./timezone-mapping";
import countries from "./countries";

export function getLocalTimezone() {
  var userTimeZone;

  if (Intl) {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    return null;
  }

  if (userTimeZone) {
    return userTimeZone;
  }
}

export function getLocalCountryCode() {
  var userCity;
  var userCountry;
  var userTimeZone;

  if (Intl) {
    userTimeZone = getLocalTimezone();
    var tzArr = userTimeZone.split("/");
    userCity = tzArr[tzArr.length - 1];
    userCountry = timezoneMapping[userCity];
  } else {
    return null;
  }

  if (userCountry) {
    return userCountry.code;
  }
}

export function getCountryFromCode(countryCode) {
  const country = countries.find((country) => country.code === countryCode);
  return country;
}

export function getCountryPhoneCode(countryCode) {
  const country = getCountryFromCode(countryCode);
  return country.phone_code;
}

export function getCountryName(countryCode) {
  const country = getCountryFromCode(countryCode);
  return country.name;
}
